import { Link } from 'react-router-dom';

export default function AreasSection() {
  const areas = [
    { name: 'Chorleywood', slug: 'chorleywood' },
    { name: 'Rickmansworth', slug: 'rickmansworth' },
    { name: 'Northwood', slug: 'northwood' },
    { name: 'Pinner', slug: 'pinner' },
    { name: 'Bushey', slug: 'bushey' },
    { name: 'Radlett', slug: 'radlett' },
    { name: 'Gerrards Cross', slug: 'gerrards-cross' },
    { name: 'Watford', slug: 'watford' },
  ];

  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-wider uppercase text-amber-600 mb-3">
            Service Areas
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Areas We Serve
          </h2>
          <p className="text-base text-neutral-500 max-w-2xl mx-auto">
            Delivering quality painting and decorating services throughout Hertfordshire and surrounding communities
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mb-12">
          {areas.map((area, index) => (
            <Link
              key={index}
              to={`/areas/${area.slug}`}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 text-center group border border-beige-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-beige-100 rounded-full mx-auto mb-3 group-hover:bg-amber-500 transition-colors">
                <i className="ri-map-pin-line text-2xl text-amber-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-sm font-bold text-gray-800 group-hover:text-amber-600 transition-colors">
                {area.name}
              </h3>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/areas"
            className="inline-flex items-center gap-2 px-8 py-4 bg-sky-500 hover:bg-sky-600 text-white font-bold rounded-lg transition-colors duration-300 whitespace-nowrap"
          >
            <span>View All Areas</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
